import appConfig from '../config/app.config.js';

/**
 * API配置文件
 * 管理API基础URL和其他API相关配置
 */

// 获取API基础URL
function getApiBaseUrl(): string {
  // 如果使用相对路径，则使用当前域名
  if (appConfig.isDevelopment) {
    // 开发环境使用配置的地址
    return `${appConfig.getApiBaseUrl()}/api`;
  } else {
    // 生产环境使用相对路径，自动使用当前域名
    return '/api';
  }
}

// 导出API配置
export default {
  // API基础URL
  baseURL: getApiBaseUrl(),
  
  // 请求超时时间（毫秒）
  timeout: 10000,
  
  // 文件上传超时时间（毫秒）- 更长时间用于大文件上传
  uploadTimeout: 300000, // 5分钟
  
  // 默认请求头
  headers: {
    'Content-Type': 'application/json'
  },
  
  // 获取完整的API URL
  getFullUrl(path: string): string {
    return `${this.baseURL}${path}`;
  },
  
  // 打印当前API配置（调试用）
  printConfig(): void {
    if (appConfig.isDebugEnabled()) {
      console.log('📋 当前API配置:', {
        baseURL: this.baseURL,
        timeout: this.timeout,
        uploadTimeout: this.uploadTimeout,
        environment: appConfig.getEnvironment()
      });
    }
  }
}; 